/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AgregarCarrito from './AgregarCarrito';
import styles from './Store.module.css';
import {
    PLACEHOLDER_IMG,
    formatearPrecio,
    tienePrecio,
    tituloArticulo,
    urlDetalle,
    urlImagen,
} from './storeUtils';

// Copia la logica de CardMarcas (imagen, placeholder, AddItem solo con token y Precio)
const TarjetaProducto = ({ articulo, vista, token, stockReal }) => {
    const [t] = useTranslation('global');
    const [imgFalla, setImgFalla] = useState(false);

    const conPrecio = tienePrecio(articulo);
    const stock = Number(articulo.Stock) || 0;
    const garantia = Number(articulo.Garantia_meses) || 0;
    const titulo = tituloArticulo(articulo);
    const detalle = urlDetalle(articulo);

    // stockReal: sesion iniciada y la API informa precios. Al visitante la API le manda Stock 0
    // para todo, asi que solo ahi el 0 significa "sin stock" (aunque el backend omita el Precio)
    const sinStock = stockReal && stock <= 0;

    let tagStock = null;
    if (sinStock) {
        tagStock = <span className={`${styles.tag} ${styles.tagSinStock}`}>{t('store.sin-stock')}</span>;
    } else if (stockReal) {
        if (stock <= 5) tagStock = <span className={`${styles.tag} ${styles.tagAmbar}`}>{t('store.stock-n', { n: stock })}</span>;
        else tagStock = <span className={`${styles.tag} ${styles.tagVerde}`}>{t('store.stock-n', { n: stock })}</span>;
    }

    return (
        <article className={`${styles.tarjeta} ${vista === 'lista' ? styles.tarjetaLista : ''}`}>
            <div className={styles.fotoWrap}>
                <Link
                    to={detalle}
                    className={`${styles.foto} ${sinStock ? styles.fotoApagada : ''}`}
                    tabIndex={-1}
                    aria-hidden="true"
                >
                    <img
                        src={imgFalla ? PLACEHOLDER_IMG : urlImagen(articulo)}
                        alt=""
                        loading="lazy"
                        onError={() => setImgFalla(true)}
                    />
                </Link>
                {sinStock && <span className={styles.cartelSinStock} aria-hidden="true">{t('store.sin-stock')}</span>}
            </div>

            <div className={styles.cuerpo}>
                <div className={styles.cuerpoInfo}>
                    <span className={styles.sku}>{articulo.Alias}</span>
                    <Link to={detalle} className={styles.titulo}>
                        {titulo}
                    </Link>
                    <span className={styles.marcaTarjeta}>{articulo.Marca}</span>

                    <div className={styles.tags}>
                        {tagStock}
                        {garantia > 0 && (
                            <span className={`${styles.tag} ${styles.tagGris}`}>
                                {t('store.garantia-tag', { n: garantia })}
                            </span>
                        )}
                    </div>
                </div>

                <div className={styles.cuerpoAcciones}>
                    {conPrecio && (
                        <div className={styles.precio}>
                            <small>{articulo.Moneda_Signo}</small> {formatearPrecio(articulo.Precio)}
                        </div>
                    )}
                    <div className={styles.acciones}>
                        {token && conPrecio && <AgregarCarrito producto={articulo} />}
                        <Link to={detalle} className={`${styles.btn} ${styles.btnGhost}`}>
                            {t('producto.ver-producto')}
                        </Link>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default TarjetaProducto;
